import axiosInstance from "./axiosInstance";

const getRooms = async (dateFrom, dateTo) => {
  return await axiosInstance
    .get(
      `${process.env.REACT_APP_BASE_URL}/reservatio-obtenerHabitaciones?date_from=${dateFrom}&date_to=${dateTo}`,
      {
        withCredentials: true,
      }
    )
    // .get(
    //   `${process.env.REACT_APP_RESERVATIO_URL}/available_rooms?date_from=${dateFrom}&date_to=${dateTo}`,
    //   {
    //     headers: {
    //       Token: process.env.REACT_APP_RESERVATIO_TOKEN,
    //     },
    //   }
    // )
    .then((res) => res)
    .catch((err) => err);
};

export default getRooms;
